import { Reducer } from 'redux';

import { QuestionActivityForNetworkLoadAction } from '../../domains/questionActivityForNetwork/actions.types';

import { QuestionActivityForNetworkLifecycle } from './types';

const initialState: QuestionActivityForNetworkLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<QuestionActivityForNetworkLifecycle, QuestionActivityForNetworkLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'QUESTION_ACTIVITY_FOR_NETWORK.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'QUESTION_ACTIVITY_FOR_NETWORK.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.networkQuestionActivity };
    case 'QUESTION_ACTIVITY_FOR_NETWORK.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
